;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:offsoo-landing":true});}catch(e){}}();import type { LegalPageKey } from '@/content/legal'

export const legalDialogKeys: readonly LegalPageKey[] = [
  'legal-terms',
  'legal-privacy',
  'legal-cookie',
  'legal-security',
  'legal-api-terms',
  'legal-dpa',
  'legal-support-service',
  'legal-responsible-disclosure',
  'legal-subprocessors',
  'legal-acceptable-use',
]
